import { render, staticRenderFns } from "./ColliDataTable.vue?vue&type=template&id=71452d1a"
import script from "./ColliDataTable.vue?vue&type=script&lang=js"
export * from "./ColliDataTable.vue?vue&type=script&lang=js"
import style0 from "./ColliDataTable.vue?vue&type=style&index=0&id=71452d1a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports